export default "__VITE_ASSET__B_gt4DGK__"